import { Link } from "react-router-dom";

/** The 8-point star (two overlapping squares) used as the site's mark. */
export function StarMark({ className = "w-7 h-7" }: { className?: string }) {
  return (
    <svg viewBox="0 0 32 32" className={className} aria-hidden="true" focusable="false">
      <g fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round">
        <rect x="7" y="7" width="18" height="18" />
        <rect x="7" y="7" width="18" height="18" transform="rotate(45 16 16)" />
        <circle cx="16" cy="16" r="3.2" />
      </g>
    </svg>
  );
}

/** Mark + wordmark, linking home. */
export default function BrandMark({ onClick }: { onClick?: () => void }) {
  return (
    <Link to="/" onClick={onClick} className="group flex items-center gap-2.5 shrink-0" aria-label="Deen Over Dunya — home">
      <span className="text-[var(--color-gold)] transition-transform duration-700 ease-[cubic-bezier(0.16,1,0.3,1)] group-hover:rotate-45">
        <StarMark />
      </span>
      <span className="font-display text-[19px] leading-none tracking-[-0.01em] text-[var(--color-cream)] whitespace-nowrap">
        Deen <em className="italic text-[var(--color-cream)]/55">over</em> Dunya
      </span>
    </Link>
  );
}
